/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_DeleteInputs */



/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Member_DeleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const member_delete = /** @type {((inputs?: Member_DeleteInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_DeleteInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Excluir")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina")
	return /** @type {LocalizedString} */ ("Delete")
});